import React, { useContext, useEffect, useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import { withSnackbar } from "../../utils/common/SnackbarHoc";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  renderTicketReadmoreDetails,
} from "../../utils/common/common";
import { getDateTime } from "../../utils/data";

const TicketChatDetails = (props: any) => {
  const { detailRow, pageType } = props;

  const renderChatDetails = (details: any) => {
    if (details && details.chats && details.chats.length > 0) {
      return (
        <>
          {details.chats.map((chat: any) => {
            return renderNewChat(chat);
          })}
        </>
      );
    }
    return <></>;
  };
  const renderNewChat = (chat: any) => {
    return (
      <>
        <Grid
          container
          spacing={2}
          sx={{
            pt: 1,
            display: "flex",
          }}
        >
          <Grid item xs={12} md={1.3} sx={{ position: "relative" }}>
            <Typography className="" sx={{ fontWeight: 500, fontSize: "11px" }}>
              Human
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={7.7}
            sx={{ position: "relative", fontSize: "11px" }}
          >
            <Typography className="" sx={{ fontSize: "11px" }}>
              {chat["human"]}{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3} sx={{ position: "relative" }}>
            <Typography className="" sx={{ fontSize: "11px" }}>
              {getDateTime(chat["startTime"])}{" "}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={2}
          sx={{
            pt: 1,
            display: "flex",
          }}
        >
          <Grid item xs={12} md={1.3} sx={{ position: "relative" }}>
            <Typography sx={{ fontWeight: 500, fontSize: "11px" }}>
              Chatbot
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={7.7}
            sx={{ position: "relative", fontSize: "11px" }}
          >
            <Typography className="" sx={{ fontSize: "11px" }}>
              {chat["chatbot"]}{" "}
            </Typography>
          </Grid>
          <Grid item xs={12} md={3} sx={{ position: "relative" }}>
            <Typography className="" sx={{ fontSize: "11px" }}>
              {getDateTime(chat["endTime"])}{" "}
            </Typography>
          </Grid>
        </Grid>
      </>
    );
  };
  return (
    <Box className="user-reports tickets">
      {detailRow?.feedbackComments &&
        Object.keys(detailRow.feedbackComments).length > 0 &&
        detailRow?.feedbackComments &&
        detailRow?.feedbackComments.chats &&
        detailRow?.feedbackComments.chats.length > 0 && (
          <Accordion defaultExpanded>
            <AccordionSummary
              aria-controls={"panel1-content"}
              id={"panel1-header"}
            >
              <Typography className="title-sm1 accordianTitle">
                Chatbot vs User chats
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "0px 0px 10px 15px !important" }}>
              <Box sx={{ maxHeight: "250px", overflowY: "auto" }}>
                {detailRow?.feedbackComments &&
                Object.keys(detailRow.feedbackComments).length > 0
                  ? renderChatDetails(detailRow.feedbackComments)
                  : "-"}
              </Box>
            </AccordionDetails>
            {/* <Box
              sx={{ padding: "0px 0px 10px 15px !important" }}
              className="read-more-link"
              style={{ display: "inline-block" }}
            >
              <Typography>Read More</Typography>
            </Box> */}
          </Accordion>
        )}
    </Box>
  );
};

export default withSnackbar(TicketChatDetails);
